import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import {
  SettingDefinition,
  SettingDefinitionProps,
} from "../../settingDefinition/models/SettingDefinition";

export const useEntitySettings = (
  entityType: string
): {
  fetch: Omit<UseFetchResult<SettingDefinitionProps[]>, "data">;
  data: SettingDefinition[];
} => {
  const { data, ...fetch } = useFetch<SettingDefinitionProps[]>(
    `/api/${entityType}/settings/keys`,
    {
      method: "get",
      initialData: [],
    }
  );


  const definitions = (data ?? []).map(
    (def) => new SettingDefinition(def)
  );

  return {
    fetch,
    data: definitions,
  };
};
